import React from 'react';

import { ORDER_ASC } from './constants';

import SortingDesktop from './components/SortingDesktop';
import { SortingMobile } from './components/SortingMobile';

import type { SortingProps } from './types';

/**
 * Компонент сортировки поисковой выдачи для страниц search и explore
 */
export const Sorting = ({
  isMobile = false,
  order = ORDER_ASC,
  className,
  ...props
}: SortingProps) => {
  const SortingComponent = isMobile ? SortingMobile : SortingDesktop;
  return <SortingComponent {...props} order={order} className={className} />;
};
